import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
export const StyledDialog = styled.dialog.withConfig({ displayName: "auir-611444a-StyledDialog", componentId: "auir-611444a-jpygfx" }) `
  @keyframes show {
    from {
      opacity: 0;
      transform: translateY(40px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  box-sizing: border-box;
  background-color: var(${(props) => props.theme.colors.background.level[2]});
  border: 0;
  padding: var(${(props) => props.theme.responsive.spacing.l})
    var(${(props) => props.theme.responsive.spacing.pageMargin});
  width: 100%;
  max-width: 100%;
  inset-block-start: auto;

  &[open] {
    animation: show 0.42s var(${(props) => props.theme.easing}) forwards;
  }

  &::backdrop {
    background-color: #000000;
    opacity: 70%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.l}px) {
    max-width: 600px;
    inset-block-start: revert;
    padding: var(${(props) => props.theme.responsive.spacing.l});
  }
`;
export const StyledDialogCloseButton = styled.div.withConfig({ displayName: "auir-611444a-StyledDialogCloseButton", componentId: "auir-611444a-1a66u1o" }) `
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  padding: 0;
  margin: -16px -24px -4px 0;

  background-color: transparent;
  border: none;
  border-radius: 0;
  cursor: pointer;

  appearance: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.m}px) {
    margin: -16px -32px -4px 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.l}px) {
    margin: -16px -16px -4px 0;
  }
`;
//# sourceMappingURL=Dialog.styles.mjs.mjs.map